import type { IPlatform, SecureStore } from './types'

const webSecureStore: SecureStore = {
  get(key) {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, value)
    } catch {
      /* quota or disabled storage — silent */
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key)
    } catch {
      /* ignore */
    }
  },
}

export const webPlatform: IPlatform = {
  kind: 'web',
  isNative: false,
  secureStore: webSecureStore,
  openExternal(url) {
    window.open(url, '_blank', 'noopener,noreferrer')
  },
  titleBar: 'native',
  isFullScreen: () => false,
  onFullScreenChange: () => () => {},
}
